import { useState, useCallback, useEffect } from "react";
import { message } from "antd";
import type { GetKycQuestionnaireSendQuery } from "../../graphql";
import sdk from "../../sdk";

export const useKycQuestionnaireSendDetail = ({ _id }: { _id: string }) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<GetKycQuestionnaireSendQuery | null>(null);

  const getSendDetail = useCallback(() => {
    setLoading(true);
    sdk
      .getKycQuestionnaireSend({ _id })
      .then((data) => setData(data))
      .catch((err) => {
        message.warn(err.response?.errors[0]?.message, 2);
      })
      .finally(() => setLoading(false));
  }, [_id]);

  const resend = useCallback(() => {
    setLoading(true);
    sdk
      .resendKycQuestionnaire({ sendId: _id })
      .then(() => {
        message.success("Амжилттай дахин илгээгдлээ", 2);
        getSendDetail();
      })
      .catch((err) => {
        message.warn(err.response?.errors[0]?.message, 2);
      })
      .finally(() => setLoading(false));
  }, [_id, getSendDetail]);

  useEffect(() => {
    getSendDetail();
  }, [getSendDetail]);

  return {
    data: data?.getKycQuestionnaireSend,
    loading,
    resend,
    getSendDetail,
  };
};
